import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img src="https://static.readdy.ai/image/e0c23ab56dcc0e27655cbb4fe89c2248/a8230b0283bd2948bd02a6ccedff45cb.png" alt="David Rio Web" className="h-20 w-auto" />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.contact')}
            </button>

            <div className="flex items-center gap-2 ml-4 border-l pl-4">
              <button 
                onClick={() => changeLanguage('es')} 
                className={`text-xs font-medium px-2 py-1 rounded transition-colors whitespace-nowrap cursor-pointer ${i18n.language === 'es' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                ES
              </button>
              <button 
                onClick={() => changeLanguage('en')} 
                className={`text-xs font-medium px-2 py-1 rounded transition-colors whitespace-nowrap cursor-pointer ${i18n.language === 'en' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                EN
              </button>
              <button 
                onClick={() => changeLanguage('ru')} 
                className={`text-xs font-medium px-2 py-1 rounded transition-colors whitespace-nowrap cursor-pointer ${i18n.language === 'ru' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                RU
              </button>
            </div>
          </div>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)} 
            className="md:hidden text-gray-700 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t pt-4">
            <div className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors text-left cursor-pointer">
                {t('nav.services')}
              </button>
              <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors text-left cursor-pointer">
                {t('nav.about')}
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors text-left cursor-pointer">
                {t('nav.contact')}
              </button>
              <div className="flex items-center gap-2 pt-2 border-t">
                <button 
                  onClick={() => changeLanguage('es')} 
                  className={`text-xs font-medium px-3 py-1.5 rounded transition-colors whitespace-nowrap cursor-pointer ${i18n.language === 'es' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
                >
                  ES
                </button>
                <button 
                  onClick={() => changeLanguage('en')} 
                  className={`text-xs font-medium px-3 py-1.5 rounded transition-colors whitespace-nowrap cursor-pointer ${i18n.language === 'en' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
                >
                  EN
                </button>
                <button 
                  onClick={() => changeLanguage('ru')} 
                  className={`text-xs font-medium px-3 py-1.5 rounded transition-colors whitespace-nowrap cursor-pointer ${i18n.language === 'ru' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
                >
                  RU
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}